import WeatherApp from '../src/components/WeatherApp/WeatherApp';
import './App.css';

function App() {
  return (
    <WeatherApp></WeatherApp>
  );
}

export default App;
